import React from 'react';
import { Button } from '@/components/ui/button';
import { ProfessionAutocomplete } from '@/components/ui/ProfessionAutocomplete';
import { BusinessTypeAutocomplete } from '@/components/ui/BusinessTypeAutocomplete';
import { Input } from '@/components/ui/input';
import { useI18n } from '@/contexts/I18nContext';

type ProfessionWizardStepProps = {
  selected: string;
  setSelected: React.Dispatch<React.SetStateAction<string>>;
  businessType: string;
  setBusinessType: React.Dispatch<React.SetStateAction<string>>;
  linkedinProfile: string;
  setLinkedinProfile: React.Dispatch<React.SetStateAction<string>>;
};

export function ProfessionWizardStep({ 
  selected, 
  setSelected, 
  businessType, 
  setBusinessType, 
  linkedinProfile,
  setLinkedinProfile
}: ProfessionWizardStepProps) {
  const { t } = useI18n();
  const isEntrepreneur = selected === t('onboarding.profession.entrepreneur');

  return (
    <div>
      <h2 className="text-lg font-semibold mb-2 font-sans">{t('onboarding.profession.title')}</h2>
      <p className="mb-4 text-black font-sans">{t('onboarding.profession.profession_label')}</p>
      <ProfessionAutocomplete
        value={selected}
        onChange={setSelected}
        placeholder={t('onboarding.profession.profession_placeholder')}
      />

      {isEntrepreneur && (
        <div className="mt-6">
          <h3 className="text-lg font-semibold mb-2 font-sans">{t('onboarding.profession.business_type_label')}</h3>
          <p className="mb-4 text-[#b0b0b0] font-sans">{t('onboarding.profession.business_type_placeholder')}</p>
          <BusinessTypeAutocomplete
            value={businessType}
            onChange={setBusinessType}
            placeholder={t('onboarding.profession.business_type_placeholder')}
          />
        </div>
      )}

      {/* Campo de LinkedIn */}
      <div className="mt-6">
        <Input
          placeholder={t('onboarding.profession.linkedin_placeholder')}
          value={linkedinProfile}
          onChange={e => setLinkedinProfile(e.target.value)}
          className="bg-white text-black placeholder:text-[#b0b0b0] border-black font-sans"
          labelColor="#b0b0b0"
        />
      </div>
    </div>
  );
} 